module.exports = __webpack_public_path__ + "img/start.77fd3921.png";